import type {
  CreateTrialAccountCommand,
} from "@/domain/model/Registration";
import type { RegistrationService } from "@/domain/port/RegistrationService";
import type { TokenBundle } from "../model/Auth";
import type { SessionStore } from "../port/SessionStore";

export class CreateTrialAccount {
  constructor(
    private readonly service: RegistrationService,
    private readonly sessionStore: SessionStore
  ) { }

  async execute(
    command: CreateTrialAccountCommand,
    signal?: AbortSignal,
  ): Promise<void> {
      const res: TokenBundle = await this.service.createTrialAccount(command, signal);
      this.sessionStore.set(res)
  }
}
